
// src/web/components/google-signin-provider.jsx

import React from 'react'
import {
  Button,
} from 'react-toolbox/lib/button'
import "isomorphic-fetch"; // or import the fetch polyfill you installed
import AccessToken from '../../actions/outlook-access-token'
import Tooltip from 'react-toolbox/lib/tooltip';
import { track } from '../../helpers/analytics';

const styles = {
  container: {
    marginTop: 8
  },
  loginBottun: {
    display: 'inline-block',
    background: '#303fa8',
    color: '#fff',
    width: '100%',
    fontWeight: 'bold',
  },
};

const loginRequest = {
  scopes: [
    'https://graph.microsoft.com/Calendars.Read',
    'https://graph.microsoft.com/Calendars.ReadBasic',
    'https://graph.microsoft.com/User.Read'
  ], // 認可するスコープを指定します
  prompt: 'login',
  sid: '1234567890', // セッションIDを指定します
}

export class MicrosoftLogin extends React.PureComponent {
  state = { isAuthenticated: false, username: ''}

  constructor(props){
    // ログイン状態のチェック
    super()
    const accounts = props.msalClient.getAllAccounts();
    if (accounts.length > 0 && !props.isOutlookCalendarFetchFailed) {
      const request = {
        scopes: [
          'https://graph.microsoft.com/Calendars.Read',
          'https://graph.microsoft.com/Calendars.ReadBasic',
          'https://graph.microsoft.com/User.Read'
        ], // 認可するスコープを指定
        sid: '1234567890', // セッションIDを指定
        prompt: 'none',
        account: accounts[0]
      }
      props.msalClient.acquireTokenSilent(request).then((res) => {
        const microsoftAccess = {
          accessToken: res.accessToken,
          username: res.account.username
        }
        AccessToken.set(microsoftAccess)
        props.onSuccess(microsoftAccess.username)
      })
    }
  }

  login = () => {
    track('onMicrosoftSigninClick')
    const account = this.props.msalClient.getActiveAccount();
    if(!account){
      // Remove the old item in sessionStorage before sending the login request
      if (sessionStorage.getItem('msal.interaction.status')) {
        sessionStorage.removeItem('msal.interaction.status');
      }
      
      this.props.msalClient.loginPopup(loginRequest).then((res) => {
        this.setState({ username: res.account.username })
        const microsoftAccess = {
          accessToken: res.accessToken,
          username: res.account.username
        }
        this.props.loadAccessToken(microsoftAccess)
        this.props.onSuccess(microsoftAccess.username)
      })
    } else {
      this.props.msalClient.acquireTokenSilent(account)
    }
  }

	render() {
			return (
        <div style={styles.container}>
          <Button primary style={styles.loginBottun} onClick={this.login} label={this.props.label} />
        </div>
      )
	}
}



// WEBPACK FOOTER //
// ./src/web/components/MicrosoftLogin.jsx